(function () {
    function submitButtons(form) {
        return form.querySelectorAll("button[type=submit], input[type=submit]");
    }

    function setBusy(form, busy) {
        var buttons = submitButtons(form);

        for (var i = 0; i < buttons.length; i++) {
            if (busy) {
                buttons[i].className += " is-submitting";
            } else {
                buttons[i].className = buttons[i].className.replace(/\s*is-submitting\b/g, "");
            }
        }
    }

    // Capture phase: a bubbling listener would be lost if anything upstream stops
    // propagation, and plenty of this codebase's forms are Incoding-bound.
    document.addEventListener("submit", function (e) {
        var form = e.target;

        if (!form || form.tagName !== "FORM") {
            return;
        }

        // The repeat submit is blocked here, which is what actually prevents a double
        // POST. The button styling below is only feedback.
        if (form.getAttribute("data-submitting") === "true") {
            e.preventDefault();
            return;
        }

        form.setAttribute("data-submitting", "true");

        // Deliberately a class, never `disabled`: disabling the submit button of a
        // form that is mid-submit aborts the submission in some engines, which looks
        // like "the click registered, the button dimmed, and nothing was sent".
        setTimeout(function () {
            if (e.defaultPrevented) {
                form.removeAttribute("data-submitting");
                setBusy(form, false);
                return;
            }

            setBusy(form, true);
        }, 0);
    }, true);

    // Restoring from the bfcache replays the old DOM, busy buttons included.
    window.addEventListener("pageshow", function (e) {
        if (!e.persisted) {
            return;
        }

        var forms = document.querySelectorAll("form[data-submitting]");

        for (var i = 0; i < forms.length; i++) {
            forms[i].removeAttribute("data-submitting");
            setBusy(forms[i], false);
        }
    });
})();
